export default class BddvdModal{

    constructor(){
        this._init();
    }


    show(key){
        this.$modalCont =  document.querySelector('.bddvdmodal__img');
        this.$modalCont.src = `/2022/assets/img/blu-ray_dvd/top/${key}`;
        this.$modal.classList.add('-active');
        this._pageFix();
    }


    hide(){
        this.$modalCont.src = '';
        this.$modal.classList.remove('-active');
        this._pageRet();
    }


    _init(){
        this.sy = 0;

        this.$wrapper = document.querySelector('.l-wrapper');
        this.$nowCast = null;
        this.$modal = document.querySelector('.bddvdmodal');
        this._ui();
    }


    _ui(){
        const openList = [...document.querySelectorAll('.js-modal-open')];
        openList.forEach($open => {

            $open.addEventListener('click', ()=>{
                const key = $open.getAttribute('data-key');
                this.show(key);
            });
        });

        document.querySelector('.js-modal-close').addEventListener('click', ()=>{
            this.hide();
        });
    }


    _pageFix(){
        this.sy = window.scrollY;
        this.$wrapper.style.position = "fixed";
        this.$wrapper.style.top = `-${this.sy}px`;
        window.scrollTo(0, 0);
    }

    _pageRet(){
        this.$wrapper.style.position = "relative";
        this.$wrapper.style.top = 0;
        window.scrollTo(0, this.sy);
    }
}